/* PRDGY quick-add modal cleanup v2 — Dawn SEO duplicate theme test only.
   Scope: closes only Shopify's stale quick-add modal/scroll lock after add-to-cart.
   It does not edit/block GoKwik, Kwikpass, KwikCart, checkout, or payment scripts. */
(function () {
  if (window.__PRDGY_QUICKADD_MODAL_CLEANUP_V2__) return;
  window.__PRDGY_QUICKADD_MODAL_CLEANUP_V2__ = true;

  var DEBUG = /[?&]prdgy_qa=1\b/.test(location.search);
  var lastQuickAddSubmitAt = 0;
  function log() { if (DEBUG) console.log.apply(console, ['[PRDGY quickadd cleanup v2]'].concat([].slice.call(arguments))); }

  function isVisible(el) {
    if (!el) return false;
    var s = getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden' || s.opacity === '0') return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function gokwikLayerPresent() {
    return !!document.querySelector('#iframe-kp, iframe.iframe-kp, #gokwik-iframe, iframe[src*="gokwik"], iframe[src*="kwikpass"], script[src*="kwikcart"]');
  }

  function closeQuickAdd(modal, reason) {
    if (!modal || !modal.matches('quick-add-modal')) return false;
    if (!modal.hasAttribute('open') && !modal.open) return false;
    log('closing quick-add modal:', reason, modal.id || '');
    try {
      if (typeof modal.hide === 'function') modal.hide(true);
      else throw new Error('hide unavailable');
    } catch (e) {
      modal.removeAttribute('open');
      modal.open = false;
      modal.classList.remove('active');
      try { modal.dispatchEvent(new CustomEvent('modalClosed', { bubbles: true })); } catch (_) {}
    }
    return true;
  }

  function cleanupBodyLock(reason) {
    var openQuickAdd = document.querySelector('quick-add-modal[open]');
    if (openQuickAdd) return false;
    // Do not remove GoKwik/KwikCart. Only release Shopify's leftover page lock.
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');
    log('released body lock:', reason);
    return true;
  }

  function scan(reason) {
    var now = Date.now();
    var recentQuickAdd = now - lastQuickAddSubmitAt < 12000;
    document.querySelectorAll('quick-add-modal[open]').forEach(function (modal) {
      var submit = modal.querySelector('button[type="submit"], [type="submit"]');
      var stillLoading = !!(submit && (submit.classList.contains('loading') || submit.getAttribute('aria-disabled') === 'true'));
      var stale = recentQuickAdd && (gokwikLayerPresent() || !stillLoading || now - lastQuickAddSubmitAt > 1800);
      if (stale) closeQuickAdd(modal, reason);
    });
    if (recentQuickAdd || document.body.classList.contains('overflow-hidden')) {
      setTimeout(function () { cleanupBodyLock(reason); }, 80);
      setTimeout(function () { cleanupBodyLock(reason + ':late'); }, 700);
    }
  }

  function markQuickAdd(source, modal) {
    lastQuickAddSubmitAt = Date.now();
    log('quick-add submit observed:', source, modal && modal.id);
    [350, 700, 1200, 2200, 4000, 7000].forEach(function (delay) {
      setTimeout(function () { scan(source + ':' + delay); }, delay);
    });
  }

  document.addEventListener('submit', function (evt) {
    var modal = evt.target && evt.target.closest && evt.target.closest('quick-add-modal');
    if (modal) markQuickAdd('submit', modal);
  }, true);

  document.addEventListener('click', function (evt) {
    var btn = evt.target && evt.target.closest && evt.target.closest('quick-add-modal button[type="submit"], quick-add-modal [type="submit"]');
    if (btn) markQuickAdd('click', btn.closest('quick-add-modal'));
  }, true);

  try {
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
        lastQuickAddSubmitAt = Date.now();
        scan('cartUpdate');
      });
    }
  } catch (e) { log('subscribe unavailable', e && e.message); }

  // Safety net: only acts shortly after a quick-add submit or if a quick-add modal is still open.
  setInterval(function () {
    if (Date.now() - lastQuickAddSubmitAt < 12000 || document.querySelector('quick-add-modal[open]')) scan('interval');
  }, 1000);
})();
